import { useTrackPageView } from "../../../analytics/pageTracking";

/**
 * Records buyer page_view events on route changes (app-wide).
 */
export default function BuyerAnalyticsTracker() {
  useTrackPageView();
  return null;
}
